const hasDeviceId = (device) => Boolean(device?.deviceId);

export const usableMediaDevices = (list = []) => ({
  audioInputs: list.filter((device) => device.kind === 'audioinput' && hasDeviceId(device)),
  videoInputs: list.filter((device) => device.kind === 'videoinput' && hasDeviceId(device)),
  audioOutputs: list.filter((device) => device.kind === 'audiooutput' && hasDeviceId(device)),
});

export async function probeMediaPermissions({ audio = false, video = false } = {}) {
  if ((!audio && !video) || !navigator.mediaDevices?.getUserMedia) return;
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: audio || false,
    video: video || false,
  });
  stream.getTracks().forEach((track) => track.stop());
}

export async function enumerateStudioDevices({
  probeAudio = false,
  probeVideo = false,
  allowProbe = false,
} = {}) {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return { audioInputs: [], videoInputs: [], audioOutputs: [] };
  }
  let list = await navigator.mediaDevices.enumerateDevices();
  let devices = usableMediaDevices(list);
  const needsAudio = probeAudio && devices.audioInputs.length === 0;
  const needsVideo = probeVideo && devices.videoInputs.length === 0;
  if (allowProbe && (needsAudio || needsVideo)) {
    try {
      await probeMediaPermissions({ audio: needsAudio, video: needsVideo });
    } catch {
      // Permission may be denied, or no matching device is attached.
    }
    list = await navigator.mediaDevices.enumerateDevices();
    devices = usableMediaDevices(list);
  }
  return devices;
}
